import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'nepali-rupee',
  size: 24,
  node: [
    ['path', { d: 'M18 16.173 A4.74 4.74 0 0 0 13.496 8.005', key: 'p7db3b' }],
    ['path', { d: 'M4 3 L20 3', key: '6x0y31' }],
    ['path', { d: 'M5 13 L13.5 21', key: '7ltufq' }],
    ['path', { d: 'M5 13 L9 13', key: '3nhwrb' }],
    ['path', { d: 'M8 13 C15.5 13 14.667 3 8 3', key: 'fx539z' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name NepaliRupee
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTggMTYuMTczIEE0Ljc0IDQuNzQgMCAwIDAgMTMuNDk2IDguMDA1IiAvPgogIDxwYXRoIGQ9Ik00IDMgTDIwIDMiIC8+CiAgPHBhdGggZD0iTTUgMTMgTDEzLjUgMjEiIC8+CiAgPHBhdGggZD0iTTUgMTMgTDkgMTMiIC8+CiAgPHBhdGggZD0iTTggMTMgQzE1LjUgMTMgMTQuNjY3IDMgOCAzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/nepali-rupee
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const NepaliRupee = createLucideIcon(__iconData);

export default NepaliRupee;
